<template>
  <div class="service">
    <img class="logo" src="@/assets/brand_hvit.svg" />
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
  .service {
    text-align: center;
  }
  .logo {
    width: 500px;
    margin: 0 auto;
    animation: zoom 1s infinite;
  }

  @keyframes zoom {
    0% { width: 500px; }
    50% { width: 510px; }
    100% { width: 500px; }
  }
</style>



// WEBPACK FOOTER //
// src/views/service/Start.vue